import { render, staticRenderFns } from "./AccountStatementTable.vue?vue&type=template&id=9f72dfca&"
import script from "./AccountStatementTable.vue?vue&type=script&lang=js&"
export * from "./AccountStatementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports